// add property co occupant string overrides here
export default {

	manage_co_occupants: {
		en: "Manage Co-Occupants",
		ar: "إدارة بيانات القاطنين",
	},
	co_oc_del_confirm: {
		en: "Do you want to delete the Co-occupant?",
		ar: "هل ترغب في حذف بيانات القاطنين ؟",
	},
	co_oc_updated: {
		en: "Co-Occupants have been successfully updated on your contract.",
		ar: "تم إضافة بيانات القاطنين بنجاح إلى عقدك.",
	},
	add_co_occupant: {
		en: "Add Co-Occupant",
		ar: "أضف بيانات قاطن آخر",
	},
	emirates_id_of_co_occupant: {
		en: "Emirates ID of Co-Occupant",
		ar: "الهوية الإماراتية للقاطن ",
	},
	dob_of_co_occupant: {
		en: "Date of Birth of Co-Occupant",
		ar: "تاريخ ميلاد القاطن",
	},
	no_co_occupants_yet: {
		en: "You have not added any Co-Occupant yet.",
		ar: "لم تقم بإضافة أي بيانات للقاطنين حتى الآن",
	},
	co_occupants: {
		en: "Co-Occupants",
		ar: "بيانات القاطنين",
	},
	add_more_co_occupants: {
		en: "Add more Co-Occupants",
		ar: "أضف مزيد قاطن",
	},
};
